import { createRouter, createHashHistory } from '@tanstack/react-router';

import { capturePolynomicClient } from '@/features/login/polynomic-client';
import { createAuthContext, type AuthContext } from '@/lib/auth';

import { routeTree } from './routeTree.gen';

const isElectron = window.location.protocol === 'file:';

capturePolynomicClient();

export interface RouterContext {
  auth: AuthContext;
}

export const router = createRouter({
  routeTree,
  history: isElectron ? createHashHistory() : undefined,
  context: {
    auth: createAuthContext(),
  },
});
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }

  // optional, otherwise every route is forced to declare staticData
  interface StaticDataRouteOption {
    requiresAuth?: boolean;
    paneSurface?: 'translucent';
    headerOverlay?: boolean;
    headerTitle?: 'page';
  }
}
